import {
  FLOW_SET_NAME,
  FLOW_SET_STATE_NAME,
  FLOW_SET_STATE_TRANSITIONS,
  FLOW_SET_STATE_VIEW_CONTENT,
  FLOW_SET_STATE_VIEW_OPTIONS,
  FLOW_SET_COMPANY_ICON
} from './types'

export default {
  [FLOW_SET_NAME]({ commit }, payload) {
    commit(FLOW_SET_NAME, payload)
  },

  [FLOW_SET_COMPANY_ICON]({ commit }, payload) {
    commit(FLOW_SET_COMPANY_ICON, payload)
  },

  [FLOW_SET_STATE_NAME]({ commit }, payload) {
    commit(FLOW_SET_STATE_NAME, payload)
  },

  [FLOW_SET_STATE_TRANSITIONS]({ commit }, payload) {
    commit(FLOW_SET_STATE_TRANSITIONS, payload)
  },

  [FLOW_SET_STATE_VIEW_CONTENT]({ commit }, payload) {
    commit(FLOW_SET_STATE_VIEW_CONTENT, payload)
  },

  [FLOW_SET_STATE_VIEW_OPTIONS]({ commit }, payload) {
    commit(FLOW_SET_STATE_VIEW_OPTIONS, payload)
  }
}
